// extracted by mini-css-extract-plugin
export var typingIndicator = "_p0-0";